import Transform from "@ember-data/serializer/transform";

export default class MillisecondsAsSecondsTransform extends Transform {
  deserialize(serialized) {
    if (serialized === null) {
      return null;
    }

    return parseInt(serialized, 10) / 1000;
  }

  serialize(deserialized) {
    if (deserialized === null) {
      return undefined;
    }

    return parseInt(deserialized, 10) * 1000;
  }
}
